import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LoginComponent } from "./components/login.component";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { LoginService } from "./services/login.service";

import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ForgotUsernameComponent } from "./forgot-username/forgot-username.component";
import { PasswordResetByAdminComponent } from "./password-reset-by-admin/password-reset-by-admin.component";
import { LoginPageComponent } from "./login-page/login-page.component";
import { Top5DialogComponent } from "./top5-dialog/top5-dialog.component";
import { Top5Service } from "./top5-dialog/shared/data.service";
import { SetEmailDialogComponent } from "./set-email-dialog/set-email-dialog.component";
import { MissingEmailWarningDialogComponent } from "./missing-email-warning-dialog/missing-email-warning-dialog.component";
import { LoginPageSSOComponent } from "./login-page-sso/login-page-sso.component";
import { SuLoginComponent } from "./login-page/su-login/su-login.component";
import { NormalLoginComponent } from "./login-page/normal-login/normal-login.component";
import { MfaInstructionsComponent } from "./login-page/mfa-instructions/mfa-instructions.component";
import { LoginLogoComponent } from "./login-page/login-logo/login-logo.component";
import { SuPasswordResetComponent } from "./su-password-reset/su-password-reset.component";
import { ColorPickerModule } from "ngx-color-picker";

@NgModule({
	declarations: [
		LoginComponent,
		ForgotUsernameComponent,
		PasswordResetByAdminComponent,
		LoginPageComponent,
		Top5DialogComponent,
		SetEmailDialogComponent,
		MissingEmailWarningDialogComponent,
		LoginPageSSOComponent,
		SuLoginComponent,
		NormalLoginComponent,
		MfaInstructionsComponent,
		LoginLogoComponent,
		SuPasswordResetComponent,
	],
	imports: [CommonModule, FormsModule, AppSharedModule, ConfirmDialogModule, ColorPickerModule],
	providers: [LoginService, ConfirmationService, Top5Service],
})
export class LoginModule {}
